import { createSelector } from 'reselect';

const modalsSelector = (state) => state.modal;

const modalSelector = (state, modal) => modalsSelector(state)[modal] || {};

const makeShowSelector = () => createSelector(modalSelector, (modal) => modal.show);

export { makeShowSelector };
